export async function initializeOffice(): Promise<void> {
  if (typeof Office === "undefined") {
    return;
  }

  return new Promise((resolve) => {
    Office.onReady(() => resolve());
  });
}
